var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarmer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.563,
    height: 38.564,
    viewBox: "0 0 38.563 38.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-21_1_",
    "data-name": "svgexport-21 (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Planting",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M139.256,174.631c3.069,0,6.1-2.281,9.058-2.281a4.357,4.357,0,0,1,4.228,2.922,1.278,1.278,0,1,0,2.34-1.011,11.441,11.441,0,0,0-18.948-2.19,1.357,1.357,0,0,0,.792,2.212A16.363,16.363,0,0,0,139.256,174.631Z",
    transform: "translate(-125.397 -155.349)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M10.846,38.563H.6a.6.6,0,0,1-.6-.6V31.333a14.262,14.262,0,0,1,1.9-7.557c1.66-2.583,4.263-3.892,7.738-3.892.853,0,3.3.6,4.218.6a18.764,18.764,0,0,0,6.664-1.759c5.973-2.391,7.07,4.145,3.881,5.352-2.352.89-6.372,1.512-8.267,3.334l10.081-2.653,5.772-5.195c.812-3.684,1.013-8.721,5.971-8.721a.61.61,0,0,1,.594.7c-.063.377-1.675,10.9-1.976,11.173l-9.641,9.641c-.208.264-13.285,3.16-13.609,3.234a2.416,2.416,0,0,0-1.881,2.365A.6.6,0,0,1,10.846,38.563ZM30.684.877c-.2-.064-4.824-1.549-7.9-.47a6.834,6.834,0,0,0-3.48,2.36A6.678,6.678,0,0,0,15.83.383c-3.052-1.07-7.645.43-7.839.495a.609.609,0,0,0-.315.9c.942,1.444,4.059,5.8,8.558,5.8a4.261,4.261,0,0,0,2.446-.708V10.92a.6.6,0,1,0,1.205,0V6.937c1.384.964,3.616.712,5.223.15,3.08-1.079,5.78-5.133,5.893-5.3a.61.61,0,0,0-.316-.9Z",
    transform: "translate(0 0)",
    fill: "#797979"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmer);
export default __webpack_public_path__ + "static/media/Farmer.a50b46a471bce595f01088f04f164ae3.svg";
export { ForwardRef as ReactComponent };